export const sidebarWidth = 305;

export const fieldWidth = {
  default: { minWidth: 268 },
  medium: { minWidth: 240 },
  large: { minWidth: 300 },
  auto: { minWidth: 'auto' },
  maximum: { width: '100%' },
};
